import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { checkJwtToken } from "../helpers/fakebackend_helper";

const Authmiddleware = (props) => {
  const [isValid, setIsValid] = useState(null);

  useEffect(() => {
    const authUser = localStorage.getItem("authUser");
    if (!authUser) {
      setIsValid(false);
      return;
    }

    const parsed = JSON.parse(authUser);
    if (!parsed || !parsed.token) {
      setIsValid(false);
      return;
    }

    checkJwtToken(parsed.token)
      .then(() => setIsValid(true))
      .catch(() => setIsValid(false));
  }, []);

  if (isValid === false) {
    localStorage.removeItem("authUser");
    return <Navigate to={{ pathname: "/login", state: { from: props.location } }} />;
  }

  if (isValid === null) {
    return null; // or a loader/spinner if desired
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

export default Authmiddleware;